<template>
    <div id="GetUserPhone">
        <nav-bar>
            <div slot="left">
                <van-icon name="arrow-left" color="#666666" size="20" @click="goBack"/>
            </div>
            <div slot="title" style="font-weight: 800; font-size: 15px;  letter-spacing:2px;">{{langText.accountsSecurity}}</div>
        </nav-bar>
        <div style="height: 120px; width: 100%;"></div>
        <div style="width: 100%; height: 136px; text-align:center ">
                <br/>
                <span style="font-size: 15px;">{{langText.title}}</span>
                <br/>
                <br/>
                <span style="font-size: 22px; letter-spacing:1px;">{{telephone}}</span>
        </div>
        <div style="text-align:center">
            <van-button round type="info" style="width: 300px;" @click="goSetPhone">{{langText.buttonTitle}}</van-button>
            <br/>
            <br/>
            <van-button round plain  type="info" style="width: 300px;" @click="goBack"> {{langText.goBack}} </van-button>
        </div>
    </div>
</template>

<script>
    import NavBar from "@/components/common/navbar/NavBar";
    import { Icon, Button  } from 'vant'
    import {getAccounts} from "@/network/mine/account"

    import { langPackage } from "@/config/lang/accountsLang";
    import { selectLang } from "@/config/setLanguage";
    // const arr = [];
    export default {
        name: "setUserPhone",
        components: {
            NavBar:NavBar,
            [Icon.name]: Icon,
            [Button.name]: Button,
        },
        data(){
            return{
                loginFrom:{
                    accountname:"agg123456789",
                    telephone:""
                },
                titleButton:"",
                lang:"cn",
                langText:{},
                commonText:{},
            }
        },
        methods:{
            goBack(){
                this.$router.back(-1);
            },
            goSetPhone(){
                this.$router.push("/mine/accounts/setPhone");
            },

        },
        computed:{
            //手机加密
            telephone:function(){
                let telephone = this.loginFrom.telephone;
                if(telephone.length != 11 && telephone != ''){
                    return telephone;
                }
                telephone = telephone.replace(telephone.substring(3,telephone.length - 2), '******')
                return telephone;
            }
        },
        created() {
            //获取语言包
            selectLang(langPackage).then(langtxt =>{
                this.langText = langtxt.langtxt;
                this.commonText = langtxt.common;

                //获取会员名字和手机号码
                return getAccounts();
            }).then((res)=>{
                if (res.code == 200){
                    this.loginFrom.accountname = res.data.username;
                    if (res.data.phone.length == 11 && res.data.phone != 0){
                        this.loginFrom.telephone = res.data.phone;
                    }else {
                        this.loginFrom.telephone = this.langText.title2;
                        this.titleButton = "点击绑定手机号码";
                    }
                }
            })
        }
    }
</script>

<style scoped>
#GetUserPhone{
    background: #f8f6f7;
    /*height: 800px;*/
    width: 100%;
}

</style>
